<template>
  <div class="collapse_item__wrappers mb-2">
    <div class="collapse_item__header mb-1">
      <div class="collapse_item__header_icon">
        <span @click="toggle">
          <i v-if="!closed()" class="el-icon-caret-bottom" />
          <i v-else class="el-icon-caret-top" />
        </span>
      </div>
      <div class="collapse_item__header_text" @click="toggle">
        <slot name="title">
          <span>{{ title }}</span>
        </slot>
      </div>
    </div>
    <div class="collapse_item__body">
      <el-collapse-transition>
        <div v-show="!closed()">
          <slot />
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>
export default {
  props: { title: { type: String, default: '' } },
  inject: ['open', 'close', 'toggle', 'closed'],
}
</script>

<style lang="scss" scoped>
.collapse_item__wrappers {
  .collapse_item__header {
    display: flex;
    align-items: center;
    .collapse_item__header_icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      margin-right: 6px;
    }
    .collapse_item__header_text {
      flex: 1;
      line-height: 20px;
      font-size: 14px;
      font-weight: 600;
    }
  }
}
</style>
